/* eslint-disable @typescript-eslint/ban-types */
import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Table, Button, Space, Tag, Row, Input, Spin, Select, Form } from 'antd';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getProfesseurs } from './personnel.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { faDownload, faSearch, faUpload } from '@fortawesome/free-solid-svg-icons';
import { getEcole } from '../ecole/ecole.reducer';
import { getClasses } from '../classe/classe.reducer';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { Storage } from 'react-jhipster';
import axios from 'axios';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';

export const Personnel = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );

  const [apiUrl, setApiUrl] = useState('');
  const [download, setDownload] = useState(false);
  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getClasses(props.match.params.ecoleid));
    sortEntities();
  }, [paginationState.activePage]);

  const currentEcole = useAppSelector(state => state.ecole.entity);
  const { match } = props;
  const profs = useAppSelector(state => state.professeur.entities);
  const totalItems = useAppSelector(state => state.professeur.totalItems);
  const loading = useAppSelector(state => state.professeur.loading);
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');

  const professeurListe = () => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getProfesseurs(entity));
  };
  const sortEntities = () => {
    professeurListe();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    if (page) {
      setPaginationState({
        ...paginationState,
        activePage: +page,
      });
    }
  }, [props.location.search]);

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const onSearch = val => {
    const entity = {
      ...val,
      ecoleId: props.match.params.ecoleid,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getProfesseurs(entity));
    setDownload(true);
    let statutPresence;
    let matricule;
    let nom, prenom;
    let classe;
    let searchUrl = '';
    if (entity.matricule) {
      matricule = '&matricule=' + entity.matricule;
      searchUrl += matricule;
    }
    if (entity.nom) {
      nom = '&nom=' + entity.nom;
      searchUrl += nom;
    }
    if (entity.prenom) {
      prenom = '&prenom=' + entity.prenom;
      searchUrl += prenom;
    }
    if (entity.classe) {
      classe = '&classe=' + entity.classe;
      searchUrl += classe;
    }
    if (entity.statutPresence) {
      statutPresence = '&statutPresence=' + entity.statutPresence;
      searchUrl += statutPresence;
    }
    if (!entity.matricule && !entity.nom && !entity.prenom && !entity.classe && !entity.etatPaiement && !entity.statutPresence) {
      setApiUrl(`/api/professeurs/download?ecoleId=${entity.ecoleId}`);
    } else {
      setApiUrl(`/api/professeurs/download?ecoleId=${entity.ecoleId}${searchUrl ? '' : '?'}${searchUrl}`);
    }
  };

  const downloadProf = () => {
    axios({
      url: apiUrl,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'personnel.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  };
  const columns = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
    },
    {
      title: 'Prénoms',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'Poste',
      dataIndex: 'poste',
      key: 'poste',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: type => <Tag color="yellow">{type}</Tag>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (status === 'PRESENT' ? <Tag color="green">{status}</Tag> : <Tag color="red">{status}</Tag>),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/personnel/${currentEcole && currentEcole.id}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = profs.map((professeur, i) => ({
    id: professeur.id,
    nom: professeur.nom,
    prenom: professeur.prenom,
    matricule: professeur.matricule !== null ? professeur.matricule : professeur.login,
    poste: professeur.poste != null ? professeur.poste : 'Professeur',
    type: professeur.typePersonnel,
    status: professeur.statutPresence,
  }));

  return (
    <div>
      <h2 id="professeur-heading" data-cy="ProfesseurHeading">
        <Translate contentKey="korischoolApp.personnel.home.title">Gestion du Personnel</Translate>
        {isNotComptable && isNotSurveillantGeneral && (
          <div style={{ textAlign: 'right' }}>
            <Link
              to={`${match.url}/new`}
              className="btn jh-create-entity"
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              id="jh-create-entity"
              data-cy="entityCreateButton"
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <Translate contentKey="korischoolApp.personnel.home.createLabel">Create new Personnel</Translate>
            </Link>
          </div>
        )}
      </h2>
      {download && (
        <Row className="justify-content-end">
          <Button onClick={downloadProf} type="primary" className="btn mb-2">
            <FontAwesomeIcon icon={faDownload} />
            &nbsp; Télécharger
          </Button>
        </Row>
      )}
      <Form name="basic" layout="inline" onFinish={onSearch} style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 0 }}>
        <Row>
          <Form.Item name="matricule">
            <Input placeholder="Matricule" allowClear />
          </Form.Item>
          <Form.Item name="prenom">
            <Input placeholder="Prénoms" allowClear />
          </Form.Item>
          <Form.Item name="nom">
            <Input placeholder="Nom" allowClear />
          </Form.Item>
          <Form.Item name="statutPresence">
            <Select placeholder="Status" allowClear style={{ width: 100 }}>
              <Select.Option value="PRESENT">
                <Tag color="green">Present</Tag>
              </Select.Option>
              <Select.Option value="ABSENT">
                <Tag color="red">Absent</Tag>
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="typePersonnel">
            <Select placeholder="Type" allowClear style={{ width: 150 }}>
              <Select.Option value="DIRECTEUR">
                <Tag color="orange">Directeur</Tag>
              </Select.Option>
              <Select.Option value="DIRECTEUR_ETUDE">
                <Tag color="orange">Directeur Etude</Tag>
              </Select.Option>
              <Select.Option value="SECRETAIRE">
                <Tag color="blue">Secretaire</Tag>
              </Select.Option>
              <Select.Option value="COMPTABLE">
                <Tag color="blue">Comptable</Tag>
              </Select.Option>
              <Select.Option value="ENSEIGNANT">
                <Tag color="green">Enseignant</Tag>
              </Select.Option>
              <Select.Option value="SURVEILLANT">
                <Tag color="red">Surveillant</Tag>
              </Select.Option>
              <Select.Option value="SURVEILLANT_GENERAL">
                <Tag color="red">Surveillant Général</Tag>
              </Select.Option>
              <Select.Option value="CONTROLEUR_BUS">
                <Tag color="blue">Controlleur Bus</Tag>
              </Select.Option>
              <Select.Option value="PERSONNEL">
                <Tag color="yellow">Autres</Tag>
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Form.Item>
        </Row>
        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={columns} dataSource={data.reverse()} pagination={false} />
          </Spin>
        </div>
        {totalItems ? (
          <div className={profs && profs.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};

export default Personnel;
